import { render, staticRenderFns } from "./TransferCard.vue?vue&type=template&id=4092addf&scoped=true"
import script from "./TransferCard.vue?vue&type=script&lang=js"
export * from "./TransferCard.vue?vue&type=script&lang=js"
import style0 from "./TransferCard.vue?vue&type=style&index=0&id=4092addf&prod&lang=scss&scoped=true"
import style1 from "./TransferCard.vue?vue&type=style&index=1&id=4092addf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4092addf",
  null
  
)

export default component.exports